module.exports = __webpack_public_path__ + "static/img/huiyi.ff037de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huiyi.jpg
// module id = W0Kf
// module chunks = 0